import { Injectable } from '@angular/core';
import { NotificationService } from '../../common/layout/notification.service';
import { LoadingService } from '../../common/layout/loading.service';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Injectable({
    providedIn: 'root'
})
export class GenericErrorHandlerService {

    constructor(
        private notificationService: NotificationService,
        private loadingService: LoadingService,
    ) {
    }

    public handleError(error: any) {
        this.loadingService.stop();
        if (typeof error === 'string') {
            this.notificationService.error(error);
        } else if (error && error.error.message && error.message) {
            this.notificationService.error(error.error.message);
        } else {
            const message = 'Wystąpił błąd, spróbuj ponownie później';
            this.notificationService.error(message);
        }
    }

    setFormErrors(form: FormGroup, errors: Array<{ propertyName, message }>) {
        errors.forEach(fieldError => {
            const control = form.get(fieldError.propertyName.replace('.', ','));
            control.setErrors({errorMessage: fieldError.message});
            control.markAsTouched();
        });
    }

    public showErrors(form: AbstractControl): void {
        const controls = form['controls'];
        if (isNullOrUndefined(controls) && !form.invalid) {
            return;
        }
        for (const controlKey in controls) {
            if (controls.hasOwnProperty(controlKey)) {
                if (controls[controlKey] instanceof FormArray || controls[controlKey] instanceof FormGroup) {
                    this.showErrors(controls[controlKey]);
                }
                if (controls[controlKey] instanceof FormControl) {
                    const control: FormControl = controls[controlKey] as FormControl;
                    control.updateValueAndValidity();
                    control.markAsTouched();
                }
            }
        }
    }
}
